import { VpIcon } from '@vtmn-play/react/headless';

export const AnnouncementCountersDisplay = ({
  likes,
  comments,
}: {
  likes: number;
  comments: number;
}) => (
  <section className="announcement-card__counters-display">
    <div className="announcement-card__counter">
      <span className="announcement-card__counter-icon">
        <VpIcon name="heart" />
      </span>
      <span
        className="announcement-card__counter-label"
        data-cy="like-counter"
      >
        {likes}
      </span>
    </div>
    <div className="announcement-card__counter">
      <span className="announcement-card__counter-icon">
        <VpIcon name="message" />
      </span>
      <span className="announcement-card__counter-label">
        {comments}
      </span>
    </div>
  </section>
);
